<template>
  <main>
    <!-- <Banner /> -->
    <section class="content-section container px-3">
      <h1>Search</h1>
      <div v-if="isReloading" class="reload-overlay">
        <div class="reload-spinner"></div>
        <p class="reload-text">Reloading...</p>
      </div>
      <div
        ref="wiperFinderMount"
        class="wiper-finder-mount"
        style="display:flex;justify-content:center;align-items:center;"
      />
    </section>
  </main>
</template>

<script>
import Banner from "@/components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      search: "",
      isReloading: false,
      wiperFinder: {
        domain: "app.wipernavigator.com",
        uuid: "5d3416b4-6b0b-44b4-9996-b1d3339bd3d0",
        divId: "universal-wiper-finder",
        scriptEl: null,
      },
    };
  },
  mounted() {
    const reloadKey = "search-page-reloaded-once";
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, "1");
      this.isReloading = true;
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }
    sessionStorage.removeItem(reloadKey);

    const mount = this.$refs.wiperFinderMount;
    if (!mount) return;

    // Mount point where the widget will render.
    let widgetDiv = document.getElementById(this.wiperFinder.divId);
    if (!widgetDiv) {
      widgetDiv = document.createElement("div");
      widgetDiv.id = this.wiperFinder.divId;
    }
    mount.appendChild(widgetDiv);

    // Load widget script once.
    const existing = document.querySelector(
      `script[data-wiper-finder="${this.wiperFinder.uuid}"]`,
    );
    if (existing) return;

    const script = document.createElement("script");
    script.async = true;
    script.dataset.wiperFinder = this.wiperFinder.uuid;
    script.src =
      `https://${this.wiperFinder.domain}/js/finder-initial.js` +
      `?uuid=${encodeURIComponent(this.wiperFinder.uuid)}` +
      `&div=${encodeURIComponent(this.wiperFinder.divId)}` +
      `&domain=${encodeURIComponent(this.wiperFinder.domain)}`;

    document.body.appendChild(script);
    this.wiperFinder.scriptEl = script;
  },
  beforeDestroy() {
    // Best-effort cleanup to avoid duplicating the widget after navigation.
    if (this.wiperFinder?.scriptEl?.parentNode) {
      this.wiperFinder.scriptEl.parentNode.removeChild(this.wiperFinder.scriptEl);
    }
    const widgetDiv = document.getElementById(this.wiperFinder?.divId);
    if (widgetDiv && widgetDiv.parentNode) {
      widgetDiv.parentNode.removeChild(widgetDiv);
    }
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  position: relative;
  padding-top: 32px;
  padding-bottom: 32px;
  text-align: center;
}

.content-section h1 {
  margin-bottom: 24px;
}

.wiper-finder-mount {
  justify-content: center;
}

.reload-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.reload-spinner {
  width: 42px;
  height: 42px;
  border: 4px solid #d6e9ff;
  border-top-color: #0a6ed1;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.reload-text {
  margin-top: 10px;
  margin-bottom: 0;
  color: #0a6ed1;
  letter-spacing: 0.8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (min-width: 768px) {
  .content-section {
    min-height: calc(100vh - 85px - 450px);
  }
}
</style>